/**
 * Validation utility functions - separated to avoid circular dependencies
 */
import dayjs from '../config/dayjs';

/**
 * Function that checks if the date property has already passed.
 */
export const checkIfDateHasPassed = (actionDatePassed: string) => {
    const utcDayjs = dayjs.utc();
    return utcDayjs.isSameOrAfter(dayjs.utc(actionDatePassed));
};

/**
 * Common function for checking if string is a valid email.
 */
export const checkIfEmailIsValid = (email: string | undefined | null) => {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(String(email).toLowerCase());
};

/**
 * Function for checking if valid json string
 */
export const checkIsValidJsonString = (text: string) => {
    text = typeof text !== 'string' ? JSON.stringify(text) : text;

    try {
        text = JSON.parse(text);
    } catch {
        return false;
    }

    if (typeof text === 'object' && text !== null) {
        return true;
    }

    return false;
};
